import defaultAvatar from '@src/assets/images/avatars/default.png';
import {Resource, Uid} from 'sdk/src/defines';
import AbstractFileModelResource from '../abstract/abstract-file-model-resource';

class SubscriberProfile extends AbstractFileModelResource {
    public resourceType: Resource = Resource.SUBSCRIBER_PROFILES;

    public declare dealerId: string;

    public declare subscriberId: Uid;
    public declare name: string;
    public declare ageLimit: number;
    public declare avatar: string;
    public declare createdAt: Date;
    public declare updatedAt: Date;

    public getAvatar(): string {
        return this.getImage(defaultAvatar, 'avatar');
    }
}

export default SubscriberProfile;